import { render, staticRenderFns } from "./TeacherScheduleLookup.vue?vue&type=template&id=80dd7042&"
import script from "./TeacherScheduleLookup.vue?vue&type=script&lang=js&"
export * from "./TeacherScheduleLookup.vue?vue&type=script&lang=js&"
import style0 from "./TeacherScheduleLookup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCheckbox,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsItems})
